import { useEffect } from 'react';

const useFavicon = (faviconUrl: string) => {
  useEffect(() => {
    const linkElement = document.querySelector<HTMLLinkElement>("link[rel*='icon']") ||
      document.createElement('link');
    linkElement.rel = 'shortcut icon';
    linkElement.href = faviconUrl;
    document.getElementsByTagName('head')[0].appendChild(linkElement);
  }, [faviconUrl]);
};

export default useFavicon;
